import React from "react";
import {
  MapPin, Users, Clock, ShieldCheck, BadgeCheck,
  Star, ThumbsUp, Award, Leaf, Phone,
} from "lucide-react";
import { siteConfig } from "../siteConfig";
import Reveal from "./Reveal";

const ICON_MAP = {
  MapPin, Users, Clock, ShieldCheck, BadgeCheck,
  Star, ThumbsUp, Award, Leaf, Phone,
};

const TrustBar = () => {
  const items = siteConfig.trustBar ?? [];

  return (
    <section
      className="w-full"
      style={{ backgroundColor: siteConfig.colors.primaryDark }}
    >
      <Reveal animation="fade" className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-center justify-center flex-wrap">
          {items.map(({ icon, label }, i) => {
            const Icon = ICON_MAP[icon] ?? ShieldCheck;
            return (
              <React.Fragment key={label}>
                {i > 0 && (
                  <div className="hidden sm:block w-px h-5 bg-white/20 mx-1" />
                )}
                <div className="flex items-center gap-2.5 px-5 py-6">
                  <Icon className="w-4 h-4 shrink-0 text-white" />
                  <span className="text-white font-black text-sm uppercase tracking-widest whitespace-nowrap">
                    {label}
                  </span>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
};

export default TrustBar;
